export default __webpack_public_path__ + "static/snake-preview-2-4477be251354ece8f69f962a197269de.png";